import React from 'react';
import MaterialBreadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import VehiclesGroupsLabel from '../VehiclesGroups/VehicleGroupsLabel';
import BreadcrumbsGenerator from './BreadcrumbsGenerator';

const routesList = {
  '/:org': 'Dashboard',
  '/skus': 'SKUs',
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginBottom: 4,
    '& .MuiBreadcrumbs-separator': {
      marginLeft: theme.spacing(0.25),
      marginRight: theme.spacing(0.25),
    },
  },
  link: {
    fontSize: 12,
    fontWeight: 500,
    '& > a': {
      color: theme.palette.form.textColor,
      '&:visited': {
        color: theme.palette.form.textColor,
      },
      '&:hover': {
        fontWeight: 500,
      },
    },
  },
  linkActive: {
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.secondary.light,
  },
}));

const LinkComponent = (props) => {
  const classes = useStyles();
  return <Link {...props} component="span" color="inherit" className={classes.link} />;
};

const ActiveLinkComponent = (props) => {
  const classes = useStyles();
  return <Typography {...props} component="span" color="inherit" className={classes.linkActive} />;
};

const WrapperComponent = (props) => {
  const classes = useStyles();
  return <MaterialBreadcrumbs {...props} className={classes.wrapper} />;
};

const AppBreadcrumbs = (props) => {
  return (
    <BreadcrumbsGenerator
      mappedRoutes={Object.assign({}, routesList, { '/service-groups': VehiclesGroupsLabel() })}
      WrapperComponent={WrapperComponent}
      LinkComponent={LinkComponent}
      ActiveLinkComponent={ActiveLinkComponent}
    />
  );
};

export default AppBreadcrumbs;
